/* eslint-disable dot-notation */
import { InformationsEnum, InformationsIconEnum, TGenerateSeoUrlParams } from '@search/gql-selectors/src/infoHelpers/types/InfoModel';
import type { TSearchSeoChpuMapper } from '@search/offer-search-routes/src/searchRoute/SearchSeoChpuMapper';
import { Rooms } from '@search/filter-enums/enums';
import { Renovation } from '@search/filter-enums/enums/Renovation';

const roomCountToParamHouse: Record<string, Rooms[]> = {
    1: [ Rooms.ROOM_1 ],
    2: [ Rooms.ROOM_2 ],
    3: [ Rooms.ROOM_3 ],
    // 4 и более - с разным текстом бывает
};

const roomCountToParamFlat: Record<string, Rooms[]> = {
    1: [ Rooms.ROOM_1 ],
    2: [ Rooms.ROOM_2 ],
    3: [ Rooms.ROOM_3 ],
    4: [ Rooms.ROOM_4 ],
    // 5 и более - с разным текстом бывает
};

const renovationTypeMappingByText: Record<string, Renovation[]> = {
    'чистовая отделка': [ Renovation.COSMETIC ],
    дизайнерский: [ Renovation.DESIGNED ],
    евро: [ Renovation.EURO ],
    'нужен ремонт': [ Renovation.NEED ],
    'черновая отделка': [ Renovation.NONE ],
};

type getSeoSearchRouteParamsByInformationItemParams = {
    searchSeoChpuMapper: TSearchSeoChpuMapper;
} & TGenerateSeoUrlParams;

// eslint-disable-next-line complexity
export const getSeoSearchRouteParamsByInformationItem = ({
    searchSeoChpuMapper,
    ...params
}: getSeoSearchRouteParamsByInformationItemParams) => {
    switch (params.informationKey) {
        case InformationsEnum.commisionType: return searchSeoChpuMapper['bez-komissii'];
        case InformationsEnum.depositType: return searchSeoChpuMapper['bez-zaloga'];
        case InformationsEnum.apartments: return searchSeoChpuMapper.apartamenty;
        case InformationsEnum.houseBathroomLocation: return searchSeoChpuMapper['s-sanuzlom'];
        case InformationsEnum.houseHeating: return searchSeoChpuMapper['s-otopleniem'];
        case InformationsEnum.gas: return searchSeoChpuMapper['s-gazom'];
        case InformationsEnum.water: return searchSeoChpuMapper['s-vodoj'];
        case InformationsEnum.electricity: return searchSeoChpuMapper['s-elektrichestvom'];
        case InformationsEnum.sewerage: return searchSeoChpuMapper['s-kanalizacziej'];
        case InformationsEnum.hasLift: return searchSeoChpuMapper['s-liftom'];
        case InformationsEnum.balcony: return searchSeoChpuMapper['s-balkonom'];
        case InformationsEnum.concierge: return searchSeoChpuMapper['s-konserzhem'];
        case InformationsEnum.renovationProgram: return searchSeoChpuMapper.renovacziya;
        case InformationsEnum.closedArea: return searchSeoChpuMapper['okhrana-territorii'];
        case InformationsEnum.noFurniture: return searchSeoChpuMapper['bez-mebeli'];
        case InformationsEnum.hasFurniture: return searchSeoChpuMapper['s-mebelyu'];
        case InformationsEnum.roomsCountInFlat: return { rooms: roomCountToParamFlat[params.informationValue] };
        case InformationsEnum.houseRooms: return { rooms: roomCountToParamHouse[params.informationValue] };
        case InformationsEnum.houseFloors: {
            if (Number(params.informationValue) === 1) return searchSeoChpuMapper['odnoetazhnyj'];
            if (Number(params.informationValue) === 2) return searchSeoChpuMapper['dvuhetazhnyj'];
            if (Number(params.informationValue) === 3) return searchSeoChpuMapper['trekhetazhnyj'];
            return null;
        }
        case InformationsIconEnum.duplex: return { houseCategory: [ 'DUPLEX' ] };
        case InformationsIconEnum.partHouse: return { houseCategory: [ 'PART_OF_HOUSE' ] };
        case InformationsIconEnum.townhouse: return { houseCategory: [ 'TOWNHOUSE' ] };
        case InformationsIconEnum.landIzhs: return { landStatus: [ 'IZHS' ] };
        case InformationsIconEnum.landLph: return { landStatus: [ 'AGRICULTURAL' ] };
        case InformationsIconEnum.bathroomNotCombined: {
            // for protection against bathroomCount param
            if (! Number(params.informationValue)) return { bathroom: [ 'PARTED' ] } as const;
            return null;
        }
        case InformationsIconEnum.bathroomCombined: {
            // for protection against bathroomCount param
            if (! Number(params.informationValue)) return { bathroom: [ 'COMBINED' ] } as const;
            return null;
        }
        case InformationsIconEnum.renovationDesign:
        case InformationsIconEnum.renovationEuro:
        case InformationsIconEnum.renovationRough:
        case InformationsIconEnum.renovationFine:
        case InformationsIconEnum.renovationNeed: return { renovation: renovationTypeMappingByText[params.informationValue.toLocaleLowerCase()] } as const;
        case InformationsEnum.floor: {
            if (params.extraSeoParams?.isFirstFloor) return searchSeoChpuMapper['1-etazh'];
            // @ts-ignore
            if (params.extraSeoParams?.floor) return searchSeoChpuMapper[`${params.extraSeoParams.floor}-etazh`];
            // last floor - high priority
            if (params.extraSeoParams?.isLastFloor) return searchSeoChpuMapper['poslednij-etazh'];
            return null;
        }
        case InformationsEnum.landArea: {
            // @ts-ignore
            if (params.extraSeoParams?.land) return searchSeoChpuMapper[`${params.extraSeoParams.land}-sotok`];
            return null;
        }
        case InformationsEnum.pets: return searchSeoChpuMapper['s-zhivotnymi'];
        default: null;
    }
};
